<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-12">
            <h1>
              Departments
              <router-link :to="{ name: 'DepartmentForm' }" class="btn ml-auto"
                ><i class="icon-plus"></i> New
              </router-link>
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Departments</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card">
          <div
            class="card-header py-3"
            v-if="!_.isEmpty(departments.data) && is_loading == false"
          >
            <button
              type="button"
              class="btn btn-info"
              @click="show_filter = !show_filter"
            >
              <i class="fa fa-filter"></i>Filter
            </button>
          </div>
          <form @submit.prevent="setFilters" method="GET" novalidate>
            <div class="card-body" v-if="show_filter">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="name"
                      >Name</label
                    >
                    <div class="col-md-9">
                      <input
                        type="text"
                        id="name"
                        class="form-control"
                        v-model="filter.name"
                        placeholder="Name"
                      />
                    </div>
                  </div>
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="starting_date"
                      >Starting date</label
                    >
                    <div class="col-md-9">
                      <date-picker
                        type="date"
                        id="starting_date"
                        input-class="form-control"
                        v-model="filter.starting_date"
                        lang="en"
                        format="YYYY-MM-DD"
                        value-type="YYYY-MM-DD"
                      ></date-picker>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <!-- Date range -->
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="created_at"
                      >Created Date Range</label
                    >
                    <div class="col-md-9">
                      <date-picker
                        type="datetime"
                        id="created_at"
                        input-class="form-control"
                        v-model="filter.created_at"
                        range
                        lang="en"
                        format="YYYY-MM-DD hh:mm:ss"
                        confirm
                        value-type="YYYY-MM-DD hh:mm:ss"
                      ></date-picker>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-9 offset-md-3">
                      <button type="submit" class="btn btn-common mr-2">
                        Search
                      </button>
                      <button
                        type="reset"
                        class="btn btn-warning"
                        @click="resetFilter()"
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <div class="card-body">
            <div v-if="!_.isEmpty(departments.data) && is_loading == false">
              <div class="table-responsive-md">
                <table class="table">
                  <thead>
                    <tr>
                      <th style="width: 10px">ID</th>
                      <th>
                        Name
                        <sort-icons :_sort="'name'" />
                      </th>
                      <th>Organization</th>
                      <th>Head Of Department</th>
                      <th>Description</th>
                      <th>Starting Date</th>
                      <th class="text-right">Action</th>
                    </tr>
                  </thead>
                  <tbody class="department-list">
                    <tr v-for="(department, index) in departments.data">
                      <td>{{ department.id }}</td>
                      <td>{{ department.name }}</td>
                      <td>
                        {{
                          !_.isEmpty(department.organization)
                            ? department.organization.org_name
                            : "NA"
                        }}
                      </td>
                      <td>{{ department.admin_user.name }}</td>
                      <td>
                        {{
                          !_.isEmpty(department.description)
                            ? department.description
                            : "NA"
                        }}
                      </td>
                      <td>
                        <span class="badge">{{
                          department.starting_date
                        }}</span>
                      </td>
                      <td class="text-right">
                        <router-link
                          :to="{
                            name: 'DepartmentShow',
                            params: { id: department.id },
                          }"
                          class="btn btn-view"
                        >
                          <i class="icon-eye"></i>
                        </router-link>
                        <router-link
                          :to="{
                            name: 'DepartmentEdit',
                            params: { id: department.id },
                          }"
                          class="btn btn-edit"
                        >
                          <i class="icon-edit"></i>
                        </router-link>
                        <button
                          class="btn btn-trash"
                          @click="destroy(department.id, index)"
                        >
                          <i class="icon-trash"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="mt-2 text-right d-block d-sm-none">
                Swipe <i class="icon-swipe"></i>
              </div>
            </div>

            <div
              class="p-4"
              v-if="_.isEmpty(departments.data) && is_loading == false"
            >
              <div class="no-data">
                <img src="/assets/images/no-data.svg" alt="" />
                <h3>No data found!</h3>
              </div>
            </div>
          </div>
          <div
            :class="{
              'card-footer': departments.total > departments.per_page,
            }"
          >
            <vue-pagination
              :pagination="departments"
              v-if="departments.total > departments.per_page"
              @paginate="getDepartments()"
            />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import VuePagination from "@/components/partials/PaginationComponent";
import SortIcons from "@/components/utils/SortIcons";
import { DepartmentsAPI } from "@/services/api";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

const filterable = {
  name: null,
  starting_date: null,
  created_at: null,
};

export default {
  name: "DepartmentList",
  components: {
    VuePagination,
    DatePicker,
    SortIcons,
  },
  data: () => ({
    departments: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
    },
    show_filter: false,
    filter: filterable,
    is_loading: false,
  }),
  mounted() {
    /* if (this.isMobile()) {
      window.$(document).find('.push-menu-class').trigger('click')
    } */
    this.getDepartments();
    this.$root.$on("sort-data", () => {
      this.$root.$emit("show-icon");
    });
  },
  watch: {
    "$route.query"() {
      this.getDepartments();
    },
  },
  methods: {
    getDepartments() {
      this.is_loading = true;
      const query = { ...this.filter, ...this.$route.query };
      DepartmentsAPI.index(query)
        .then((departments) => {
          this.departments = departments;
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    destroy(id, index) {
      this.$swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          confirmButtonText: "Yes, delete it!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.is_loading = true;
            DepartmentsAPI.destroy(id)
              .then((response) => {
                this.departments.data.splice(index, 1);
                this.departments.total--;
                this.$toaster.success(response.message);
              })
              .catch((error) => {
                console.log("Could not delete this:: ", error);
                this.$swal.fire("Failed!", "Failed to delete.", "error");
              })
              .finally(() => {
                this.is_loading = false;
              });
          }
        });
    },
    async setFilters() {
      await this.$router
        .push({
          path: this.$route.path,
          query: this.filter,
        })
        .catch();
    },
    resetFilter() {
      this.filter = {};
      this.$router.push({ path: this.$route.path }).catch();
      this.$root.$emit("show-icon");
      this.show_filter = false;
    },
  },
};
</script>
